export default {
  toasts: {
    auth_token_invalid: 'Auth-token ongeldig',
    host_access_refused: 'Dit adres hoort bij een partner waar uw account niet bij hoort. Log in op uw eigen adres.',
  },
};
